<script lang="ts">import genericSpinner from "./assets/spinner.svg";
import { AppMode, appMode, cfgToThemeCdnPath, stateUi } from "@infinitro/config";
import { loggedIn, showLoading } from "@infinitro/global";
import { DotLottieSvelte } from "@lottiefiles/dotlottie-svelte";
import { onMount } from "svelte";
import { writable } from "svelte/store";
export let initPageLoadDisplayFor = appMode == AppMode.Player ? $stateUi.loading.playerInitPageLoadDisplayFor : $stateUi.loading.publicInitPageLoadDisplayFor;
export let maxShowTime = 1e4;
export let customClass = "";
export let waitForLoggedIn = false;
const show = writable(initPageLoadDisplayFor > 0);
const showAnimation = writable(!waitForLoggedIn);
const onInitialPageLoad = async () => {
	if (initPageLoadDisplayFor <= 0) {
		show.set(false);
		return;
	}
	if (waitForLoggedIn) {
		let isLoggedIn = false;
		await new Promise((resolve) => {
			let unsub;
			unsub = loggedIn.subscribe((v) => {
				if (v !== undefined) {
					isLoggedIn = v === true;
					unsub?.();
					resolve();
				}
			});
		});
		if (isLoggedIn) return;
		showAnimation.set(true);
		await new Promise((resolve) => setTimeout(resolve, initPageLoadDisplayFor));
	} else {
		await new Promise((resolve) => setTimeout(resolve, initPageLoadDisplayFor));
	}
	show.set(false);
};
let timeoutTimer = undefined;
let fallback = false;
onMount(() => {
	let unsub = showLoading.subscribe((v) => {
		if (!v && timeoutTimer) {
			clearTimeout(timeoutTimer);
			timeoutTimer = undefined;
		}
		if (v && !timeoutTimer) {
			timeoutTimer = setTimeout(() => showLoading.set(false), maxShowTime);
		}
	});
	if (initPageLoadDisplayFor > 0) {
		onInitialPageLoad();
	}
	return () => {
		unsub();
		if (timeoutTimer) {
			clearTimeout(timeoutTimer);
			timeoutTimer = undefined;
		}
	};
});
const lottieSpinner = cfgToThemeCdnPath(`/loading/loading.lottie`);
const svgSpinner = cfgToThemeCdnPath(`/loading/loading.svg`);
const lottieRenderConfig = { freezeOnOffscreen: false };
const customLoading = cfgToThemeCdnPath("/misc/logo.svg");
$: useLottie = $stateUi.loading.useLottie;
$: useCustomLoading = $stateUi.loading.useCustomLoading;
$: spinner = fallback ? genericSpinner : useLottie ? lottieSpinner : svgSpinner;
</script>

{#if $show || $showLoading}
	<div
		class={`loading-screen ${customClass}`}
		on:click|preventDefault|stopPropagation={() => {}}
		on:wheel|preventDefault|stopPropagation={() => {}}
		on:touchmove|preventDefault|stopPropagation={() => {}}
	>
		{#if $showAnimation || $showLoading}
			{#if useCustomLoading}
				<img src={customLoading} alt="..." class="spinner" on:error={() => (fallback = true)} />
			{:else if useLottie && spinner && !fallback}
				<div class="lottie-container">
					<DotLottieSvelte
						src={spinner}
						loop
						autoplay
						speed={1}
						renderConfig={lottieRenderConfig}
					/>
				</div>
			{:else if spinner}
				<img src={spinner} alt="..." class="spinner" on:error={() => (fallback = true)} />
			{/if}
		{/if}
	</div>
{/if}

<style>
	.loading-screen {
		position: absolute;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100dvh;
		background-size: cover;
		background-position: center;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		z-index: 100;
		background-color: black;
	}

	.spinner {
		width: auto !important;
		max-height: 100px !important;
		max-width: 100px !important;
	}

	.lottie-container {
		width: 200px !important;
		height: 200px !important;
		max-width: 80vw !important;
		max-height: 80vh !important;
		position: relative;
		z-index: 1;
	}

	.lottie-container :global(canvas) {
		display: block;
	}
</style>
